import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "react-bootstrap";
import { Button as PrimeButton } from "primereact/button";
import { MultiSelect } from 'primereact/multiselect';
import { FilterMatchMode } from "primereact/api";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";
import axios from "axios";

import { SERVICE_LOCATION, GET_ECO_JOBS_BETWEEN_DATES, DOWNLOAD_RETRO_DOC } from "../constants/endpoints";
import { RETRO_DOC_TYPES } from "../constants/ecoJobConstants";
import { WORKCARDS_DOWNLOADED } from "./../constants/errors";

import "./../assets/styles/table.css";
import "./../assets/styles/worksheets.css";

const EcoJobs = (props) => {
    const toast = useRef(null);
    const navigate = useNavigate();

    const { data } = props;
    const userDepot = (data !== undefined && data !== null) ? data.data.userDetails.depot : "";

    const [loading, setLoading] = useState(false);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [minToDate, setMinToDate] = useState(null);
    const [disableGoButton, setDisableGoButton] = useState(null);
    const [ecoJobsData, setEcoJobsData] = useState(null);
    const [selectedEcoJobs, setSelectedEcoJobs] = useState(null);
    const [disableDownloadButton, setDisableDownloadButton] = useState(true);
    const [showRetroDocModal, setShowRetroDocModal] = useState(false);
    const [selectedRetroDocType, setSelectedRetroDocType] = useState(null);
    const [retroDocList, setRetroDocList] = useState([]);
    const [retroDocsByProduct, setRetroDocsByProduct] = useState(RETRO_DOC_TYPES);

    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState("");

    useEffect(() => {
        const currentDate = new Date();
        const previousDate = new Date(currentDate);
        previousDate.setDate(currentDate.getDate() - 2);
        setFromDate(previousDate);
        setToDate(currentDate);
        getEcoJobs(previousDate, currentDate);
        initFilters();
    }, []);

    const getFormattedDate = (dateToFormat) => {
        const year = dateToFormat.getFullYear();
        const month = String(dateToFormat.getMonth() + 1).padStart(2, "0");
        const day = String(dateToFormat.getDate()).padStart(2, "0");
        const formatedDate = `${year}-${month}-${day}`;
        return formatedDate;
    }

    const getEcoJobs = (selectedFromDate, selectedToDate) => {
        setLoading(true);
        const formatedFromDate = getFormattedDate(selectedFromDate);
        const formatedToDate = getFormattedDate(selectedToDate)
        const requestedData = {
            startDate: formatedFromDate,
            endDate: formatedToDate,
            depot: userDepot
        }
        const endPoint = SERVICE_LOCATION + GET_ECO_JOBS_BETWEEN_DATES;
        axios.post(endPoint, requestedData, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        }).then((response) => {
            setSelectedEcoJobs(null);
            if (response.data.isSuccess) {
                const processedData = response.data.data.ecoJobs;
                var updateDates = processedData.map(function (item) {
                    return { ...item, submittedDate: item.submittedDate === "1900-01-01" ? "" : item.submittedDate };
                });
                setEcoJobsData(updateDates);
            }
            else if (!response.data.isSuccess) {
                setEcoJobsData(null);
                toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 3000 });
            }
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
            toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
        })
    }

    const showRetroDocTypes = () => {
        const allDocs = RETRO_DOC_TYPES;
        const filteredList = allDocs.filter(doc => doc.ptoductType === selectedEcoJobs[0].measureType);
        setRetroDocsByProduct(filteredList);
        setShowRetroDocModal(true);
    }

    const onRetroDocModalClose = () => {
        setSelectedRetroDocType(null);
        setRetroDocList([]);
        setShowRetroDocModal(false);
    }

    const handleRetroDocDownload = () => {
        onRetroDocModalClose();
        setLoading(true);
        const requestedData = {
            jobRef: selectedEcoJobs[0].jobRef,
            reportType: retroDocList
        }
        const endPoint = SERVICE_LOCATION + DOWNLOAD_RETRO_DOC;
        axios.post(endPoint, requestedData, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        }).then((response) => {
            if (response.data.isSuccess) {
                if (response.data.data.downloadedWorkCards.length > 0) {
                    (response.data.data.downloadedWorkCards).forEach(workcard => {
                        const base64 = workcard.chunks.join("");
                        const base64String = "data:application/pdf;base64," + base64;
                        const linkSource = base64String;
                        const downloadLink = document.createElement("a");
                        const fileName = workcard.fileName;
                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        downloadLink.click();
                    });
                }
                toast.current.show({ severity: "success", summary: "Success", detail: WORKCARDS_DOWNLOADED, life: 5000 });
            }
            else if (!response.data.isSuccess) {
                toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 3000 });
            }
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
            toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
        })
    }

    const handleRetroDocTypeSelection = (e) => {
        const selectedList = e.value;
        setSelectedRetroDocType(selectedList);
        const docs = selectedList.map(doc => doc.fileName);
        setRetroDocList(docs);
    }

    const footerContent = (
        <div>
            <PrimeButton label="Cancel" onClick={onRetroDocModalClose} className="p-button-text" />
            <PrimeButton label="Download" onClick={handleRetroDocDownload} autoFocus />
        </div>
    );

    const handleGo = () => {
        getEcoJobs(fromDate, toDate);
    }

    const handleFromDate = (e) => {
        const dateSelected = e.value;
        setFromDate(dateSelected);
        setMinToDate(dateSelected);
        setToDate(null);
        setDisableGoButton(true);
    }

    const handleToDate = (e) => {
        const dateSelected = e.value;
        setToDate(dateSelected);
        setDisableGoButton(false);
    }

    // Search functionality
    const clearFilter = () => {
        initFilters();
    };

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            jobRef: { value: null, matchMode: FilterMatchMode.CONTAINS },
            clientName: { value: null, matchMode: FilterMatchMode.CONTAINS },
            address: { value: null, matchMode: FilterMatchMode.CONTAINS },
            telephone: { value: null, matchMode: FilterMatchMode.CONTAINS },
            workTel: { value: null, matchMode: FilterMatchMode.CONTAINS },
            mobile: { value: null, matchMode: FilterMatchMode.CONTAINS },
            email: { value: null, matchMode: FilterMatchMode.CONTAINS },
            propertyId: { value: null, matchMode: FilterMatchMode.CONTAINS },
            planId: { value: null, matchMode: FilterMatchMode.CONTAINS },
            propertyType: { value: null, matchMode: FilterMatchMode.CONTAINS },
            measureCode: { value: null, matchMode: FilterMatchMode.CONTAINS },
            measureDescription: { value: null, matchMode: FilterMatchMode.CONTAINS },
            measureType: { value: null, matchMode: FilterMatchMode.CONTAINS },
            jobStatus: { value: null, matchMode: FilterMatchMode.CONTAINS },
            plannedDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
            jobDepotName: { value: null, matchMode: FilterMatchMode.CONTAINS },
            resourceName: { value: null, matchMode: FilterMatchMode.CONTAINS },
            submittedBy: { value: null, matchMode: FilterMatchMode.CONTAINS },
            submittedDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
            submissionStatus: { value: null, matchMode: FilterMatchMode.CONTAINS },
            isSubmitted: { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        setGlobalFilterValue("");
    }

    const renderHeader = () => {
        return (
            <div className="row">
                <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                    <label htmlFor="from-date">From</label>
                    <Calendar id="from-date" name="from-date" value={fromDate} onChange={handleFromDate} showIcon dateFormat="dd/mm/yy" />
                </div>
                <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                    <label htmlFor="to-date">To</label>
                    <Calendar id="to-date" name="to-date" value={toDate} onChange={handleToDate} minDate={minToDate} showIcon dateFormat="dd/mm/yy" />
                </div>
                <div className="col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1 padt-23">
                    <Button id="go" label="Go" disabled={disableGoButton} onClick={handleGo}>GO</Button>
                </div>
                <div className="col-12 col-sm-7 col-md-7 col-lg-7 col-xl-7 padt-15">
                    <div className="flex justify-content-end txt-right">
                        <PrimeButton className="mar-r-10" type="button" icon="pi pi-filter-slash" label="Clear" outlined onClick={clearFilter} tooltip="clear filters" tooltipOptions={{ position: "bottom" }} />
                        <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                        </span>
                    </div>
                </div>
            </div>
        );
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters["global"].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const header = renderHeader();
    // Search functionality Ends here

    // To disbale unsubmitted eco jobs and to prevent from download
    const isSelectable = (data) => data.isSubmitted === "Y";
    const isRowSelectable = (event) => (event.data ? isSelectable(event.data) : true);
    const rowClassName = (data) => (isSelectable(data) ? "" : "p-disabled");
    // Disable functionality Ends here

    // Staus severity with colors for submission status
    const getStatusSeverity = (submissionStatus) => {
        switch (submissionStatus) {
            case "Approved":
                return "approve";
            case "Site Attention":
                return "attention";
            case "Site Revisit":
                return "revisit";
            case "Pending":
                return "pending";
            default:
                return "nocolor";
        }
    };

    const statusBodyTemplate = (job) => {
        return <span className={`status-severity ${getStatusSeverity(job.submissionStatus)}`}>{job.submissionStatus}</span>
    };
    // Staus severity with colors for submission status ends here

    const handleEcoJobSelection = (e) => {
        setSelectedEcoJobs(e.value);
        e.value.length === 1 ? setDisableDownloadButton(false) : setDisableDownloadButton(true);
    }

    return (
        <div className={`app ${loading ? "disabled" : ""}`}>
            {
                loading &&
                <div className="spinner-overlay">
                    <ProgressSpinner style={{ width: "50px", height: "50px" }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
                </div>
            }

            <Toast ref={toast} />
            <div className="worksheets-section">
                <div className="row padb-10">
                    <div className="col-3">
                        <h4>ECO JOBS</h4>
                    </div>
                    <div className="col-9 buttons-right">
                        <div className="padr-10">
                            <Button className="btn-secondary" onClick={showRetroDocTypes} disabled={disableDownloadButton}>Download Eco Job(s) PDF</Button>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <DataTable className="font-12" value={ecoJobsData} selection={selectedEcoJobs} selectionMode="checkbox"
                            onSelectionChange={handleEcoJobSelection} dataKey="id" paginator rows={10} rowsPerPageOptions={[10, 20, 50]}
                            isDataSelectable={isRowSelectable} rowClassName={rowClassName} removableSort sortMode="multiple"
                            filters={filters} header={header} filterDisplay="row"
                            globalFilterFields={["id", "submissionStatus", "jobRef", "clientName", "address", "telephone", "workTel", "mobile", "email", "propertyId", "planId",
                                "propertyType", "measureCode", "measureDescription", "measureType", "jobStatus", "plannedDate", "jobDepotName", "resourceName", "submittedBy",
                                "submittedDate", "isSubmitted"]}
                            scrollable tableStyle={{ minWidth: "100rem" }} emptyMessage="No eco jobs availabe for the selected date range.">
                            <Column selectionMode="multiple" headerStyle={{ width: "3rem" }}></Column>
                            <Column field="id" header="Id" className="table-header" hidden></Column>
                            <Column field="submissionStatus" sortable header="Submission Status" body={statusBodyTemplate} filter filterPlaceholder="Search by status" className="table-header"></Column>
                            <Column field="jobRef" sortable header="Job Ref" filter filterPlaceholder="Search by job ref" className="table-header"></Column>
                            <Column field="clientName" sortable header="Client Name" filter filterPlaceholder="Search by client name" className="table-header"></Column>
                            <Column field="address" sortable header="Address" filter filterPlaceholder="Search by address" className="table-header"></Column>
                            <Column field="telephone" sortable header="Telephone" filter filterPlaceholder="Search by telephone" className="table-header"></Column>
                            <Column field="workTel" sortable header="WorkTel" filter filterPlaceholder="Search by workTel" className="table-header"></Column>
                            <Column field="mobile" sortable header="Mobile" filter filterPlaceholder="Search by mobile" className="table-header"></Column>
                            <Column field="email" sortable header="Email" filter filterPlaceholder="Search by email" className="table-header"></Column>
                            <Column field="propertyId" sortable header="Property Id" filter filterPlaceholder="Search by property id" className="table-header"></Column>
                            <Column field="planId" sortable header="Plan Id" filter filterPlaceholder="Search by plan id" className="table-header"></Column>
                            <Column field="propertyType" sortable header="Property Type" filter filterPlaceholder="Search by property type" className="table-header"></Column>
                            <Column field="measureCode" sortable header="Measure Code" filter filterPlaceholder="Search by measure code" className="table-header"></Column>
                            <Column field="measureDescription" sortable header="Measure Description" filter filterPlaceholder="Search by measure description" className="table-header"></Column>
                            <Column field="measureType" sortable header="Measure Type" filter filterPlaceholder="Search by measure type" className="table-header"></Column>
                            <Column field="jobStatus" sortable header="Job Status" filter filterPlaceholder="Search by jobStatus" className="table-header"></Column>
                            <Column field="plannedDate" sortable header="Planned Date" filter filterPlaceholder="Search by planned date" className="table-header"></Column>
                            <Column field="jobDepotName" sortable header="Depot" filter filterPlaceholder="Search by depot" className="table-header"></Column>
                            <Column field="resourceName" sortable header="Crew" filter filterPlaceholder="Search by crew" className="table-header"></Column>
                            <Column field="submittedBy" sortable header="Submitted By" filter filterPlaceholder="Search by submittedBy" className="table-header"></Column>
                            <Column field="submittedDate" sortable header="submitted Date" filter filterPlaceholder="Search by submitted date" className="table-header"></Column>
                            <Column field="submissionType" sortable header="Submission Type" filter filterPlaceholder="Search by submission type" className="table-header"></Column>
                            <Column field="isSubmitted" sortable header="IsSubmitted" filter filterPlaceholder="Search by is submitted" className="table-header"></Column>
                        </DataTable>
                    </div>
                </div>

                <Dialog header="Retro Doc Type" visible={showRetroDocModal} style={{ width: "50vw" }} onHide={onRetroDocModalClose} footer={footerContent}>
                    <div className="row">
                        <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 padr-20">
                            <div className="flex flex-column gap-2 fitter-feild">
                                <label htmlFor="RetroDocType">Retro Document Type</label>
                                <MultiSelect value={selectedRetroDocType} onChange={handleRetroDocTypeSelection} options={retroDocsByProduct} optionLabel="retroDoc"
                                    placeholder="Select retro doc" maxSelectedLabels={3} className="w-full md:w-14rem" display="chip" />
                            </div>
                        </div>
                    </div>
                </Dialog>
            </div>
        </div>
    )
}

export default EcoJobs;